import { } from "../../core/feature/store";
import logoWhite from "../../assets/images/logo-white.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Transition } from "@headlessui/react";
import { useState } from "react";

const ComponentForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showCS, setShowCS] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [supportUsername, setSupportUsername] = useState("");
  const [supportInstitute, setSupportInstitute] = useState("");
  const [supportOpened, setSupportOpened] = useState(false);

  var name = `${t("CUSTOMER.name")}`;
  var institution = `${t("CUSTOMER.institution")}`;
  var message = `${t("CUSTOMER.message")}`;

  function sendMessage() {
    console.log(supportMessage);
    let url = "";
    let phone = "6281326269992";
    url =
      "https://wa.me/" +
      phone +
      "?text=Halo,%20saya%20" +
      supportUsername +
      "%20dari%20" +
      supportInstitute +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A" +
      supportMessage;
    setSupportOpened(false);
    window.open(url, "_blank");
  }

  return (
    <div>
      <div className="relative font-poppins p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          {/* <div>
            <img src={vector1} className="top-0 left-0 absolute z-10" />
          </div> */}
          <div className="relative overflow-visible w-3/12 sm:w-1/2 md:w-3/12 flex-0 bg-psp-login ">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="flex flex-col gap-10 w-full">
              <div className="flex flex-col z-10 gap-8 items-start">
                {/* <img src={vector1} className="ml-32 sm:ml-12 md:ml-32" /> */}
                <div className="px-10 mt-36 sm:px-10  md:px-10 md:mt-20 sm:mt-0">
                  <img src={logoWhite} className="z-10 h-14 select-none" />
                  <p className="text-white z-10 mt-6 text-xs font-light">
                    {t("LOGIN.description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full p-4 bg-psp-primary justify-center items-center relative">
            <img src={ellipse3} className="absolute top-0 -left-72 z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 z-0" />
            <div className="w-3/4 md:w-2/3 sm:w-full m-auto z-10">
              <div className="pt-40">
                <h1 className="text-gray-400 text-2xl font-medium select-none">
                  Welcome To
                </h1>
                <p className="text-black font-semibold text-4xl select-none">
                  PSP Web Dekstop
                </p>
              </div>
              <div>
                <h1 className="font-montserrat font-bold text-2xl text-black my-4">
                  {t("LOGIN.tutor")}
                </h1>
                <ol className="font-montserrat list-decimal text-slate-500 text-sm mb-0 ">
                  <li>
                    {t("LOGIN.tutor1")}
                    <span
                      className=" text-psp-primary cursor-pointer hover:underline hover:text-blue-700"
                      onClick={() => setShowCS(true)}
                    >
                      {" "}
                      {t("CUSTOMER.title")}
                    </span>
                  </li>
                  <li>{t("LOGIN.tutor2")}</li>
                  <li>{t("LOGIN.tutor3")}</li>
                  <li>{t("LOGIN.tutor4")}</li>
                </ol>
                <div className="mt-4 font-montserrat">
                  <span className="text-slate-500 text-sm px-2">
                    {t("LOGIN.rule")}
                  </span>
                  <ol className="list-decimal text-slate-500 text-sm">
                    <li>{t("LOGIN.rule1")}</li>
                    <li>{t("LOGIN.rule2")}</li>
                  </ol>
                  <button
                    onClick={() => navigate("/forgot-password-confirmation")}
                    className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
                  >
                    {t("LOGIN.next")}
                  </button>
                  <button
                    onClick={() => navigate(-1)}
                    className="mt-2 bg-[#FFC31A] text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600"
                  >
                    {t("OTHER.back")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Transition
        show={showCS}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
            <div className="relative w-auto h-auto my-6 mx-auto max-w-6xl">
              <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-psp-primary outline-none focus:outline-none py-4 px-4">
                <div className="text-xl font-semibold w-full h-auto text-center px-2 py-2 mb-3">
                  <span>{t("CUSTOMER.title")}</span>
                </div>
                <div>
                  <form>
                    <input
                      onChange={(e) => setSupportUsername(e.target.value)}
                      placeholder={name}
                      className="w-full py-2 px-3 border rounded-xl mb-2"
                    ></input>
                  </form>
                  <form>
                    <input
                      onChange={(e) => setSupportInstitute(e.target.value)}
                      placeholder={institution}
                      className="w-full py-2 px-3 border rounded-xl mb-2"
                    ></input>
                  </form>
                  <form>
                    <textarea
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder={message}
                      className="w-full py-2 px-3 border rounded-xl"
                    ></textarea>
                  </form>
                </div>
                <div className="mt-4 flex flex-row justify-center mb-1">
                  <button
                    type="button"
                    className="w-40 h-10 mr-3 rounded-md text-white bg-psp-btn-red"
                    onClick={() => setShowCS(false)}
                  >
                    {t("CUSTOMER.no")}
                  </button>
                  <button
                    type="button"
                    className="w-40 h-10 rounded-md text-white bg-psp-btn-primary"
                    onClick={() => sendMessage()}
                  >
                    {t("CUSTOMER.yes")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>
    </div>
  );
};

export default ComponentForgotPassword;
